<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9176 7.906C16.0828 8.07144 16.1756 8.2957 16.1756 8.52953C16.1756 8.76335 16.0828 8.98761 15.9176 9.15306L10.9176 14.1531C10.7521 14.3183 10.5279 14.4111 10.2941 14.4111C10.0602 14.4111 9.83597 14.3183 9.67053 14.1531L4.67053 9.15306C4.51467 8.98579 4.42982 8.76456 4.43385 8.53597C4.43789 8.30738 4.53049 8.08928 4.69215 7.92762C4.85381 7.76596 5.07191 7.67335 5.3005 7.66932C5.52909 7.66529 5.75032 7.75014 5.91759 7.906L10.2941 12.2825L14.6705 7.906C14.836 7.74076 15.0602 7.64795 15.2941 7.64795C15.5279 7.64795 15.7521 7.74076 15.9176 7.906Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronDown',
} as DefineComponent
</script>
